module.exports = __webpack_public_path__ + "static/media/me3_UniversalLearner_Image.1730cac0.png";